export const personalCenter = {
    path: '/personalCenter',
    name: 'personalCenter',
    title: '个人中心',
    component: () => import("../components/page/homePage/personalCenter"),
    meta:{title:'个人中心'},
}


// WEBPACK FOOTER //
// ./src/router/personalCenter.js